// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/highlight.js/styles/tokyo-night-dark.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-1f90ed2b] a {
  color: var(--ref-link-color);
}
[data-v-1f90ed2b] .monospace-text {
  font-family: 'SourceCodePro';
  font-size: 1.06em;
  line-height: 1em;
}
.inner-wrapper[data-v-1f90ed2b] {
  display: flex;
  flex-direction: row;
  transition: all 0.3s;
}
.inner-wrapper .select-message[data-v-1f90ed2b] {
  margin-right: 10px;
  margin-top: 4px;
  margin-left: 4px;
}
.inner-wrapper .select-message[data-v-1f90ed2b] .custom-checkbox {
  transition: all 0.3s;
}
.inner-wrapper .select-message[data-v-1f90ed2b] .custom-checkbox i {
  opacity: 1;
  font-size: 22px;
}
.inner-wrapper.select-mode[data-v-1f90ed2b]:hover {
  background-color: var(--message-selected-bgcolor);
}
.inner-wrapper.selected-message[data-v-1f90ed2b] {
  background-color: var(--message-selected-bgcolor);
}
li[data-v-1f90ed2b] {
  display: flex;
  flex-direction: column;
  max-width: var(--max-width);
  margin-top: 1px;
  transition: all 0.3s;
  z-index: 999;
}
li.select-mode[data-v-1f90ed2b] {
  display: flex;
}
li.select-mode.side-left .message-wrapper[data-v-1f90ed2b] {
  margin-left: 4px;
}
li.select-mode.side-right .message-wrapper[data-v-1f90ed2b] {
  transition-property: margin-left, margin-right;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  transition-delay: 0s;
  margin-right: 4px;
}
.item.new-msg-slide-enter-active[data-v-1f90ed2b] {
  transition: all 0.5s;
  transition-property: padding-top, padding-bottom;
}
.item.new-msg-slide-enter[data-v-1f90ed2b] {
  padding-top: 30px;
}
.item.slide-bottom.new-msg-slide-enter[data-v-1f90ed2b] {
  padding-bottom: 0;
}
.item.new-msg-slide-leave-active[data-v-1f90ed2b],
.item.new-msg-slide-leave[data-v-1f90ed2b] {
  display: none;
}
.item.side-left[data-v-1f90ed2b] {
  margin-right: auto;
}
.item.side-left .text-indent[data-v-1f90ed2b] {
  width: 45px;
}
.item.side-left .text-indent.edited-ru[data-v-1f90ed2b] {
  width: 99px;
}
.item.side-left .text-indent.edited-en[data-v-1f90ed2b] {
  width: 79px;
}
.item.side-left .message.text[data-v-1f90ed2b] {
  user-select: text;
  -webkit-user-select: text;
  cursor: text;
}
.item.side-left .message-wrapper[data-v-1f90ed2b] {
  transition: all 0.3s;
  transition-property: margin-left;
}
.item.side-left .message-footer.with-reactions[data-v-1f90ed2b] {
  margin-top: 1px;
  height: 1.55em;
}
.item.side-center[data-v-1f90ed2b] {
  margin: 0 auto;
}
.item.side-right[data-v-1f90ed2b] {
  margin-left: auto;
  text-align: right;
}
.item.side-right .message-wrapper[data-v-1f90ed2b] {
  display: grid;
  margin-left: auto;
  padding-left: 30px;
  text-align: right;
  transition-property: margin-left, margin-right;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  transition-delay: 0s;
}
.item.side-right .message-wrapper.message-mouth-right[data-v-1f90ed2b]::after {
  border-bottom-color: var(--message-right-bgcolor);
}
.item.side-right .message-wrapper.message-mouth-right-error[data-v-1f90ed2b]::after {
  border-bottom-color: var(--elem-red-color);
}
.item.side-right .message-wrapper.message-send-error .message-list-item[data-v-1f90ed2b] {
  background-color: var(--elem-red-color);
}
.item.side-right .message-wrapper .message-list-item[data-v-1f90ed2b] {
  background-color: var(--message-right-bgcolor);
}
.item.side-right .message-wrapper .message-list-item .message.text[data-v-1f90ed2b] {
  user-select: text;
  -webkit-user-select: text;
  cursor: text;
}
.item.side-right .message-wrapper .message-list-item .message-footer[data-v-1f90ed2b] {
  width: 100%;
}
.item.side-right .message-wrapper .message-list-item .message-footer .responsive-gap-left[data-v-1f90ed2b] {
  margin-left: auto;
}
.item.side-right .message-wrapper .message-list-item .message-footer .responsive-gap-right[data-v-1f90ed2b] {
  min-width: 3em !important;
}
.item.side-right .message-wrapper .message-list-item .message-footer.with-indent[data-v-1f90ed2b] {
  margin-right: -2px;
}
.item.side-right .message-wrapper .message-list-item .message-footer.with-reactions[data-v-1f90ed2b] {
  height: 1.55em;
}
.item.side-right .message-wrapper .message-list-item .message-footer.with-reactions .reactions-wrapper[data-v-1f90ed2b] {
  margin-right: 1.5em;
}
.item.side-right .message-wrapper .message-list-item .message-footer.location[data-v-1f90ed2b] {
  min-height: 1.25em;
}
.item.side-right .message-wrapper .message-list-item .message-footer.edited .responsive-gap-right[data-v-1f90ed2b] {
  min-width: 8em !important;
}
.item.side-right .text-indent[data-v-1f90ed2b] {
  width: 65px;
}
.item.side-right .text-indent.edited-ru[data-v-1f90ed2b] {
  width: 119px;
}
.item.side-right .text-indent.edited-en[data-v-1f90ed2b] {
  width: 99px;
}
.item.system-message[data-v-1f90ed2b] {
  align-items: center;
}
.item.system-message .message-list-item[data-v-1f90ed2b] {
  background-color: var(--message-system-bgcolor);
  color: var(--chat-system-color);
  padding: 3px 8px;
  border-radius: 17px;
}
.item.system-message .message-list-item .message-footer[data-v-1f90ed2b] {
  display: none !important;
}
.item.system-message .message-list-item .message.text[class*="text"][data-v-1f90ed2b] {
  margin-left: 0;
  text-align: center;
}
.item.system-message.time[data-v-1f90ed2b] {
  border-radius: 16px;
  font-size: 12px;
  filter: contrast(var(--fontContrast));
}
.item.system-message .time-message .message[data-v-1f90ed2b] {
  font-size: 12px;
  filter: contrast(var(--fontContrast));
}
.item.data-message .message-list-item[data-v-1f90ed2b] {
  display: grid;
}
.item.series-message-start .message-list-item[data-v-1f90ed2b] {
  margin-top: 4px;
  margin-bottom: 0;
}
.item.series-message .message-list-item[data-v-1f90ed2b] {
  margin-top: 1px;
  margin-bottom: 0;
}
.item.series-message-end .message-list-item[data-v-1f90ed2b] {
  margin-bottom: 4px;
}
.item .message-wrapper[data-v-1f90ed2b] {
  display: flex;
  max-width: 100%;
  position: relative;
}
.item .message-icon[data-v-1f90ed2b] {
  cursor: pointer;
  position: relative;
  margin-top: auto;
  margin-bottom: 4px;
}
.item .message-list-item[data-v-1f90ed2b] {
  display: inline-flex;
  flex-wrap: wrap;
  background: var(--message-left-bgcolor);
  border-radius: 10px;
  padding: 4px 4px;
  margin: 4px;
  text-align: right;
  width: auto;
  overflow: hidden;
}
.item .message-list-item .message-header[data-v-1f90ed2b] {
  text-align: left;
  margin: 2px 5px 2px 5px;
}
.item .message-list-item .message-header .name-signature[data-v-1f90ed2b] {
  font-size: 12px;
  font-weight: bold;
}
.item .message-list-item .message-header .name-signature span[data-v-1f90ed2b] {
  cursor: pointer;
}
.item .message-list-item .message-header .name-signature span[data-v-1f90ed2b]:hover {
  text-decoration: underline;
}
.item .message-list-item .message-body[data-v-1f90ed2b] {
  text-align: left;
  display: flex;
  flex-direction: column;
  margin-top: 0;
  word-wrap: break-word;
}
.item .message-list-item .message-body .message[data-v-1f90ed2b] {
  display: flex;
  white-space: pre-wrap;
  justify-content: left;
  width: var(--image-width);
  max-width: fit-content;
  min-width: var(--min-msg-width);
}
.item .message-list-item .message-body .message.text[data-v-1f90ed2b] {
  display: inline-block;
  flex-direction: column;
  max-width: 100%;
  filter: contrast(var(--fontContrast));
  line-height: 1.8rem;
  word-break: break-word;
  margin: 0 4px;
  word-wrap: anywhere;
  user-select: text;
  -webkit-user-select: text;
}
.item .message-list-item .message-body .message.text .aux-gap[data-v-1f90ed2b] {
  visibility: hidden;
  float: right;
  height: 1.35rem;
  width: 80px;
}
.item .message-list-item .message-body .message.text[data-v-1f90ed2b] .code {
  font-family: 'SourceCodePro';
  font-size: 0.98em;
  color: var(--code-block-font-color);
  background-color: #363a3e;
  line-height: 1.14em;
  border-radius: 0.5em;
  margin-bottom: -8px;
  padding: 2px;
  margin-top: 4px;
}
.item .message-list-item .message-body .message.with-url-preview[data-v-1f90ed2b] {
  max-width: 350px;
}
.item .message-list-item .message-body .message.url-preview[data-v-1f90ed2b] {
  display: flex;
  flex-direction: column;
  padding: 0.5em;
  color: whitesmoke;
  background-color: #56697c;
  border-radius: 8px;
  margin: 2px auto 6px auto;
  cursor: pointer;
}
.item .message-list-item .message-body .message.url-preview img[data-v-1f90ed2b] {
  width: var(--text-max-width);
  max-height: 250px;
  object-fit: cover;
}
.item .message-list-item .message-body .message.group-caption[data-v-1f90ed2b] {
  position: relative;
  max-width: var(--text-max-width);
  margin-top: -12px;
}
.item .message-list-item .message-body .message .sender[data-v-1f90ed2b] {
  color: var(--special-blue-color);
  font-weight: bold;
}
.item .message-list-item .message-body .message .chat-contact-message[data-v-1f90ed2b] {
  display: flex;
}
.item .message-list-item .message-body .message .chat-contact-message > *[data-v-1f90ed2b] {
  margin: auto;
}
.item .message-list-item .message-body .message .chat-contact-message .contact-name[data-v-1f90ed2b] {
  margin-left: 10px;
}
.item .message-list-item .message-body .message .chat-geo-message[data-v-1f90ed2b] {
  width: 300px;
  height: 200px;
}
.item .message-list-item .message-body .message .chat-image-message[data-v-1f90ed2b],
.item .message-list-item .message-body .message .chat-video-message .preview-block[data-v-1f90ed2b] {
  position: relative;
  cursor: pointer;
}
.item .message-list-item .message-body .message .chat-image-message .img-wrapper[data-v-1f90ed2b],
.item .message-list-item .message-body .message .chat-video-message .preview-block .img-wrapper[data-v-1f90ed2b] {
  display: flex;
  max-height: 250px;
  overflow: hidden;
  align-items: center;
  border-radius: 10px;
}
.item .message-list-item .message-body .message .chat-image-message .img-wrapper img[data-v-1f90ed2b],
.item .message-list-item .message-body .message .chat-video-message .preview-block .img-wrapper img[data-v-1f90ed2b] {
  width: 251px;
}
.item .message-list-item .message-body .message .chat-video-message img[data-v-1f90ed2b] {
  filter: blur(4px);
}
.item .message-list-item .message-body .message .chat-document-file-message[data-v-1f90ed2b] {
  word-break: break-word;
  display: grid;
  grid-template-columns: 50px minmax(50px, auto) 50px;
}
.item .message-list-item .message-body .message .chat-document-file-message > *[data-v-1f90ed2b] {
  margin: auto;
}
.item .message-list-item .message-body .message .chat-document-file-message .document-file-name[data-v-1f90ed2b] {
  word-break: break-word;
}
.item .message-list-item .next[data-v-1f90ed2b] {
  color: #83C1EF;
  cursor: pointer;
  margin-left: 5px;
  margin-top: 3px;
  font-size: 13px;
}
.item .message-list-item .next[data-v-1f90ed2b]:hover {
  text-decoration: underline;
}
.item .message-list-item .caption[data-v-1f90ed2b] {
  margin-top: var(--margin-caption-top) !important;
  max-width: var(--text-max-width) !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 0 4px;
}
.item .message-list-item .audio-caption[data-v-1f90ed2b] {
  margin-top: 15px !important;
  max-width: var(--text-max-width) !important;
}
.item .message-list-item .bot-message span[data-v-1f90ed2b] {
  color: #23527c;
  text-decoration: underline;
  cursor: pointer;
}
.item .text-indent[data-v-1f90ed2b] {
  display: inline-block;
}
.item .message-footer[data-v-1f90ed2b] {
  position: relative;
  display: flex;
  align-items: baseline;
  margin-top: 0px;
  font-size: .8em;
  min-height: 0.8em;
  transition: opacity 1s;
}
.item .message-footer.with-indent[data-v-1f90ed2b] {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.item .message-footer .responsive-gap[data-v-1f90ed2b] {
  margin-left: auto;
}
.item .message-footer.with-reactions > div[data-v-1f90ed2b] {
  margin-top: 0;
}
.item .message-footer.with-reactions .responsive-gap-left[data-v-1f90ed2b] {
  margin-left: auto;
}
.item .message-footer.with-reactions .responsive-gap-right[data-v-1f90ed2b] {
  min-width: 2.8em;
}
.item .message-footer.with-reactions.with-status .responsive-gap-right[data-v-1f90ed2b] {
  min-width: 4em !important;
}
.item .message-footer.with-reactions.location[data-v-1f90ed2b] {
  min-height: 1.25em;
}
.item .message-footer.with-reactions.edited .responsive-gap-right[data-v-1f90ed2b] {
  min-width: 8.8em !important;
}
.item .message-footer .aux[data-v-1f90ed2b] {
  position: absolute;
  display: flex;
  align-items: baseline;
  right: 0;
  bottom: -2px;
}
.item .message-footer .aux .time[data-v-1f90ed2b],
.item .message-footer .aux .edited[data-v-1f90ed2b] {
  margin-right: 2px;
  color: var(--message-grey-color);
  z-index: 2;
  right: 10px;
}
.item .message-footer .aux .edited[data-v-1f90ed2b] {
  margin-right: 3px;
}
.item .message-footer .aux .status[data-v-1f90ed2b] {
  color: #83c1ef;
  letter-spacing: -3px;
  width: 14px;
  margin-left: 2px;
  z-index: 2;
}
.item .message-footer .aux .status i[data-v-1f90ed2b] {
  padding: 5px 4px 0px 0px;
}
.item .message-footer .aux .status i.greyFont[data-v-1f90ed2b] {
  color: var(--message-grey-color);
  padding-top: 5px;
}
.item .message-footer-threads.isActive[data-v-1f90ed2b] {
  background-color: var(--bg-comments-hover-right);
}
.item .message-footer-threads.isActive.leftSide[data-v-1f90ed2b] {
  background-color: var(--bg-comments-hover-left);
}
.item .msg-right[data-v-1f90ed2b] {
  justify-content: flex-end;
}
.item .msg-left[data-v-1f90ed2b] {
  justify-content: flex-start;
}
.item .message-mouth-left[data-v-1f90ed2b]::after {
  transition: all 0.25s;
  content: '';
  position: absolute;
  left: 8px;
  top: 8px;
  width: 0;
  height: 0;
  border-bottom: 12px solid;
  border-bottom-color: var(--message-left-bgcolor);
  border-left: 14px solid transparent;
  border-right: 12px solid transparent;
  transform: translate(100%, 100%);
}
.item.active-comments .message-mouth-left[data-v-1f90ed2b]::after {
  border-bottom-color: var(--bg-comments-hover-left) !important;
}
.item.active-comments .message-mouth-right[data-v-1f90ed2b]::after {
  border-bottom-color: var(--bg-comments-hover-right) !important;
}
.item .message-mouth-left-detail[data-v-1f90ed2b]:after {
  content: '';
  position: absolute;
  left: -36px;
  bottom: 16px;
  width: 0;
  height: 0;
  border-bottom: 12px solid var(--message-left-bgcolor);
  border-left: 14px solid transparent;
  border-right: 12px solid transparent;
  transform: translate(100%, 100%);
}
.item.last[data-v-1f90ed2b] {
  overflow: hidden;
  transition: all 0.25s;
  transition-property: height, margin-bottom, opacity;
  opacity: 0.2;
}
.item.height-change[data-v-1f90ed2b] {
  height: 30px;
}
.item.height-change[data-v-1f90ed2b]:last-child {
  margin-bottom: 0;
}
.item.animation[data-v-1f90ed2b] {
  min-height: 38px;
  opacity: 1;
}
.item.animation.height-change[data-v-1f90ed2b] {
  height: var(--max-height);
}
.item.animation.height-change[data-v-1f90ed2b]:last-child {
  margin-bottom: 30px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatMessage.vue"],"names":[],"mappings":"AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;EAC9C,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mDAAmD;AACrD;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gDAAgD;EAChD,2CAA2C;EAC3C,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;AACA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,UAAU;EACV,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gDAAgD;EAChD,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,8DAA8D;AAChE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,qDAAqD;EACrD,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD;EACnD,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB","sourcesContent":["@import 'highlight.js/styles/tokyo-night-dark.min.css';\n[data-v-1f90ed2b] a {\n  color: var(--ref-link-color);\n}\n[data-v-1f90ed2b] .monospace-text {\n  font-family: 'SourceCodePro';\n  font-size: 1.06em;\n  line-height: 1em;\n}\n.inner-wrapper[data-v-1f90ed2b] {\n  display: flex;\n  flex-direction: row;\n  transition: all 0.3s;\n}\n.inner-wrapper .select-message[data-v-1f90ed2b] {\n  margin-right: 10px;\n  margin-top: 4px;\n  margin-left: 4px;\n}\n.inner-wrapper .select-message[data-v-1f90ed2b] .custom-checkbox {\n  transition: all 0.3s;\n}\n.inner-wrapper .select-message[data-v-1f90ed2b] .custom-checkbox i {\n  opacity: 1;\n  font-size: 22px;\n}\n.inner-wrapper.select-mode[data-v-1f90ed2b]:hover {\n  background-color: var(--message-selected-bgcolor);\n}\n.inner-wrapper.selected-message[data-v-1f90ed2b] {\n  background-color: var(--message-selected-bgcolor);\n}\nli[data-v-1f90ed2b] {\n  display: flex;\n  flex-direction: column;\n  max-width: var(--max-width);\n  margin-top: 1px;\n  transition: all 0.3s;\n  z-index: 999;\n}\nli.select-mode[data-v-1f90ed2b] {\n  display: flex;\n}\nli.select-mode.side-left .message-wrapper[data-v-1f90ed2b] {\n  margin-left: 4px;\n}\nli.select-mode.side-right .message-wrapper[data-v-1f90ed2b] {\n  transition-property: margin-left, margin-right;\n  transition-duration: 0.3s;\n  transition-timing-function: ease;\n  transition-delay: 0s;\n  margin-right: 4px;\n}\n.item.new-msg-slide-enter-active[data-v-1f90ed2b] {\n  transition: all 0.5s;\n  transition-property: padding-top, padding-bottom;\n}\n.item.new-msg-slide-enter[data-v-1f90ed2b] {\n  padding-top: 30px;\n}\n.item.slide-bottom.new-msg-slide-enter[data-v-1f90ed2b] {\n  padding-bottom: 0;\n}\n.item.new-msg-slide-leave-active[data-v-1f90ed2b],\n.item.new-msg-slide-leave[data-v-1f90ed2b] {\n  display: none;\n}\n.item.side-left[data-v-1f90ed2b] {\n  margin-right: auto;\n}\n.item.side-left .text-indent[data-v-1f90ed2b] {\n  width: 45px;\n}\n.item.side-left .text-indent.edited-ru[data-v-1f90ed2b] {\n  width: 99px;\n}\n.item.side-left .text-indent.edited-en[data-v-1f90ed2b] {\n  width: 79px;\n}\n.item.side-left .message.text[data-v-1f90ed2b] {\n  user-select: text;\n  -webkit-user-select: text;\n  cursor: text;\n}\n.item.side-left .message-wrapper[data-v-1f90ed2b] {\n  transition: all 0.3s;\n  transition-property: margin-left;\n}\n.item.side-left .message-footer.with-reactions[data-v-1f90ed2b] {\n  margin-top: 1px;\n  height: 1.55em;\n}\n.item.side-center[data-v-1f90ed2b] {\n  margin: 0 auto;\n}\n.item.side-right[data-v-1f90ed2b] {\n  margin-left: auto;\n  text-align: right;\n}\n.item.side-right .message-wrapper[data-v-1f90ed2b] {\n  display: grid;\n  margin-left: auto;\n  padding-left: 30px;\n  text-align: right;\n  transition-property: margin-left, margin-right;\n  transition-duration: 0.3s;\n  transition-timing-function: ease;\n  transition-delay: 0s;\n}\n.item.side-right .message-wrapper.message-mouth-right[data-v-1f90ed2b]::after {\n  border-bottom-color: var(--message-right-bgcolor);\n}\n.item.side-right .message-wrapper.message-mouth-right-error[data-v-1f90ed2b]::after {\n  border-bottom-color: var(--elem-red-color);\n}\n.item.side-right .message-wrapper.message-send-error .message-list-item[data-v-1f90ed2b] {\n  background-color: var(--elem-red-color);\n}\n.item.side-right .message-wrapper .message-list-item[data-v-1f90ed2b] {\n  background-color: var(--message-right-bgcolor);\n}\n.item.side-right .message-wrapper .message-list-item .message.text[data-v-1f90ed2b] {\n  user-select: text;\n  -webkit-user-select: text;\n  cursor: text;\n}\n.item.side-right .message-wrapper .message-list-item .message-footer[data-v-1f90ed2b] {\n  width: 100%;\n}\n.item.side-right .message-wrapper .message-list-item .message-footer .responsive-gap-left[data-v-1f90ed2b] {\n  margin-left: auto;\n}\n.item.side-right .message-wrapper .message-list-item .message-footer .responsive-gap-right[data-v-1f90ed2b] {\n  min-width: 3em !important;\n}\n.item.side-right .message-wrapper .message-list-item .message-footer.with-indent[data-v-1f90ed2b] {\n  margin-right: -2px;\n}\n.item.side-right .message-wrapper .message-list-item .message-footer.with-reactions[data-v-1f90ed2b] {\n  height: 1.55em;\n}\n.item.side-right .message-wrapper .message-list-item .message-footer.with-reactions .reactions-wrapper[data-v-1f90ed2b] {\n  margin-right: 1.5em;\n}\n.item.side-right .message-wrapper .message-list-item .message-footer.location[data-v-1f90ed2b] {\n  min-height: 1.25em;\n}\n.item.side-right .message-wrapper .message-list-item .message-footer.edited .responsive-gap-right[data-v-1f90ed2b] {\n  min-width: 8em !important;\n}\n.item.side-right .text-indent[data-v-1f90ed2b] {\n  width: 65px;\n}\n.item.side-right .text-indent.edited-ru[data-v-1f90ed2b] {\n  width: 119px;\n}\n.item.side-right .text-indent.edited-en[data-v-1f90ed2b] {\n  width: 99px;\n}\n.item.system-message[data-v-1f90ed2b] {\n  align-items: center;\n}\n.item.system-message .message-list-item[data-v-1f90ed2b] {\n  background-color: var(--message-system-bgcolor);\n  color: var(--chat-system-color);\n  padding: 3px 8px;\n  border-radius: 17px;\n}\n.item.system-message .message-list-item .message-footer[data-v-1f90ed2b] {\n  display: none !important;\n}\n.item.system-message .message-list-item .message.text[class*=\"text\"][data-v-1f90ed2b] {\n  margin-left: 0;\n  text-align: center;\n}\n.item.system-message.time[data-v-1f90ed2b] {\n  border-radius: 16px;\n  font-size: 12px;\n  filter: contrast(var(--fontContrast));\n}\n.item.system-message .time-message .message[data-v-1f90ed2b] {\n  font-size: 12px;\n  filter: contrast(var(--fontContrast));\n}\n.item.data-message .message-list-item[data-v-1f90ed2b] {\n  display: grid;\n}\n.item.series-message-start .message-list-item[data-v-1f90ed2b] {\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n.item.series-message .message-list-item[data-v-1f90ed2b] {\n  margin-top: 1px;\n  margin-bottom: 0;\n}\n.item.series-message-end .message-list-item[data-v-1f90ed2b] {\n  margin-bottom: 4px;\n}\n.item .message-wrapper[data-v-1f90ed2b] {\n  display: flex;\n  max-width: 100%;\n  position: relative;\n}\n.item .message-icon[data-v-1f90ed2b] {\n  cursor: pointer;\n  position: relative;\n  margin-top: auto;\n  margin-bottom: 4px;\n}\n.item .message-list-item[data-v-1f90ed2b] {\n  display: inline-flex;\n  flex-wrap: wrap;\n  background: var(--message-left-bgcolor);\n  border-radius: 10px;\n  padding: 4px 4px;\n  margin: 4px;\n  text-align: right;\n  width: auto;\n  overflow: hidden;\n}\n.item .message-list-item .message-header[data-v-1f90ed2b] {\n  text-align: left;\n  margin: 2px 5px 2px 5px;\n}\n.item .message-list-item .message-header .name-signature[data-v-1f90ed2b] {\n  font-size: 12px;\n  font-weight: bold;\n}\n.item .message-list-item .message-header .name-signature span[data-v-1f90ed2b] {\n  cursor: pointer;\n}\n.item .message-list-item .message-header .name-signature span[data-v-1f90ed2b]:hover {\n  text-decoration: underline;\n}\n.item .message-list-item .message-body[data-v-1f90ed2b] {\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  margin-top: 0;\n  word-wrap: break-word;\n}\n.item .message-list-item .message-body .message[data-v-1f90ed2b] {\n  display: flex;\n  white-space: pre-wrap;\n  justify-content: left;\n  width: var(--image-width);\n  max-width: fit-content;\n  min-width: var(--min-msg-width);\n}\n.item .message-list-item .message-body .message.text[data-v-1f90ed2b] {\n  display: inline-block;\n  flex-direction: column;\n  max-width: 100%;\n  filter: contrast(var(--fontContrast));\n  line-height: 1.8rem;\n  word-break: break-word;\n  margin: 0 4px;\n  word-wrap: anywhere;\n  user-select: text;\n  -webkit-user-select: text;\n}\n.item .message-list-item .message-body .message.text .aux-gap[data-v-1f90ed2b] {\n  visibility: hidden;\n  float: right;\n  height: 1.35rem;\n  width: 80px;\n}\n.item .message-list-item .message-body .message.text[data-v-1f90ed2b] .code {\n  font-family: 'SourceCodePro';\n  font-size: 0.98em;\n  color: var(--code-block-font-color);\n  background-color: #363a3e;\n  line-height: 1.14em;\n  border-radius: 0.5em;\n  margin-bottom: -8px;\n  padding: 2px;\n  margin-top: 4px;\n}\n.item .message-list-item .message-body .message.with-url-preview[data-v-1f90ed2b] {\n  max-width: 350px;\n}\n.item .message-list-item .message-body .message.url-preview[data-v-1f90ed2b] {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5em;\n  color: whitesmoke;\n  background-color: #56697c;\n  border-radius: 8px;\n  margin: 2px auto 6px auto;\n  cursor: pointer;\n}\n.item .message-list-item .message-body .message.url-preview img[data-v-1f90ed2b] {\n  width: var(--text-max-width);\n  max-height: 250px;\n  object-fit: cover;\n}\n.item .message-list-item .message-body .message.group-caption[data-v-1f90ed2b] {\n  position: relative;\n  max-width: var(--text-max-width);\n  margin-top: -12px;\n}\n.item .message-list-item .message-body .message .sender[data-v-1f90ed2b] {\n  color: var(--special-blue-color);\n  font-weight: bold;\n}\n.item .message-list-item .message-body .message .chat-contact-message[data-v-1f90ed2b] {\n  display: flex;\n}\n.item .message-list-item .message-body .message .chat-contact-message > *[data-v-1f90ed2b] {\n  margin: auto;\n}\n.item .message-list-item .message-body .message .chat-contact-message .contact-name[data-v-1f90ed2b] {\n  margin-left: 10px;\n}\n.item .message-list-item .message-body .message .chat-geo-message[data-v-1f90ed2b] {\n  width: 300px;\n  height: 200px;\n}\n.item .message-list-item .message-body .message .chat-image-message[data-v-1f90ed2b],\n.item .message-list-item .message-body .message .chat-video-message .preview-block[data-v-1f90ed2b] {\n  position: relative;\n  cursor: pointer;\n}\n.item .message-list-item .message-body .message .chat-image-message .img-wrapper[data-v-1f90ed2b],\n.item .message-list-item .message-body .message .chat-video-message .preview-block .img-wrapper[data-v-1f90ed2b] {\n  display: flex;\n  max-height: 250px;\n  overflow: hidden;\n  align-items: center;\n  border-radius: 10px;\n}\n.item .message-list-item .message-body .message .chat-image-message .img-wrapper img[data-v-1f90ed2b],\n.item .message-list-item .message-body .message .chat-video-message .preview-block .img-wrapper img[data-v-1f90ed2b] {\n  width: 251px;\n}\n.item .message-list-item .message-body .message .chat-video-message img[data-v-1f90ed2b] {\n  filter: blur(4px);\n}\n.item .message-list-item .message-body .message .chat-document-file-message[data-v-1f90ed2b] {\n  word-break: break-word;\n  display: grid;\n  grid-template-columns: 50px minmax(50px, auto) 50px;\n}\n.item .message-list-item .message-body .message .chat-document-file-message > *[data-v-1f90ed2b] {\n  margin: auto;\n}\n.item .message-list-item .message-body .message .chat-document-file-message .document-file-name[data-v-1f90ed2b] {\n  word-break: break-word;\n}\n.item .message-list-item .next[data-v-1f90ed2b] {\n  color: #83C1EF;\n  cursor: pointer;\n  margin-left: 5px;\n  margin-top: 3px;\n  font-size: 13px;\n}\n.item .message-list-item .next[data-v-1f90ed2b]:hover {\n  text-decoration: underline;\n}\n.item .message-list-item .caption[data-v-1f90ed2b] {\n  margin-top: var(--margin-caption-top) !important;\n  max-width: var(--text-max-width) !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  padding: 0 4px;\n}\n.item .message-list-item .audio-caption[data-v-1f90ed2b] {\n  margin-top: 15px !important;\n  max-width: var(--text-max-width) !important;\n}\n.item .message-list-item .bot-message span[data-v-1f90ed2b] {\n  color: #23527c;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.item .text-indent[data-v-1f90ed2b] {\n  display: inline-block;\n}\n.item .message-footer[data-v-1f90ed2b] {\n  position: relative;\n  display: flex;\n  align-items: baseline;\n  margin-top: 0px;\n  font-size: .8em;\n  min-height: 0.8em;\n  transition: opacity 1s;\n}\n.item .message-footer.with-indent[data-v-1f90ed2b] {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n}\n.item .message-footer .responsive-gap[data-v-1f90ed2b] {\n  margin-left: auto;\n}\n.item .message-footer.with-reactions > div[data-v-1f90ed2b] {\n  margin-top: 0;\n}\n.item .message-footer.with-reactions .responsive-gap-left[data-v-1f90ed2b] {\n  margin-left: auto;\n}\n.item .message-footer.with-reactions .responsive-gap-right[data-v-1f90ed2b] {\n  min-width: 2.8em;\n}\n.item .message-footer.with-reactions.with-status .responsive-gap-right[data-v-1f90ed2b] {\n  min-width: 4em !important;\n}\n.item .message-footer.with-reactions.location[data-v-1f90ed2b] {\n  min-height: 1.25em;\n}\n.item .message-footer.with-reactions.edited .responsive-gap-right[data-v-1f90ed2b] {\n  min-width: 8.8em !important;\n}\n.item .message-footer .aux[data-v-1f90ed2b] {\n  position: absolute;\n  display: flex;\n  align-items: baseline;\n  right: 0;\n  bottom: -2px;\n}\n.item .message-footer .aux .time[data-v-1f90ed2b],\n.item .message-footer .aux .edited[data-v-1f90ed2b] {\n  margin-right: 2px;\n  color: var(--message-grey-color);\n  z-index: 2;\n  right: 10px;\n}\n.item .message-footer .aux .edited[data-v-1f90ed2b] {\n  margin-right: 3px;\n}\n.item .message-footer .aux .status[data-v-1f90ed2b] {\n  color: #83c1ef;\n  letter-spacing: -3px;\n  width: 14px;\n  margin-left: 2px;\n  z-index: 2;\n}\n.item .message-footer .aux .status i[data-v-1f90ed2b] {\n  padding: 5px 4px 0px 0px;\n}\n.item .message-footer .aux .status i.greyFont[data-v-1f90ed2b] {\n  color: var(--message-grey-color);\n  padding-top: 5px;\n}\n.item .message-footer-threads.isActive[data-v-1f90ed2b] {\n  background-color: var(--bg-comments-hover-right);\n}\n.item .message-footer-threads.isActive.leftSide[data-v-1f90ed2b] {\n  background-color: var(--bg-comments-hover-left);\n}\n.item .msg-right[data-v-1f90ed2b] {\n  justify-content: flex-end;\n}\n.item .msg-left[data-v-1f90ed2b] {\n  justify-content: flex-start;\n}\n.item .message-mouth-left[data-v-1f90ed2b]::after {\n  transition: all 0.25s;\n  content: '';\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  width: 0;\n  height: 0;\n  border-bottom: 12px solid;\n  border-bottom-color: var(--message-left-bgcolor);\n  border-left: 14px solid transparent;\n  border-right: 12px solid transparent;\n  transform: translate(100%, 100%);\n}\n.item.active-comments .message-mouth-left[data-v-1f90ed2b]::after {\n  border-bottom-color: var(--bg-comments-hover-left) !important;\n}\n.item.active-comments .message-mouth-right[data-v-1f90ed2b]::after {\n  border-bottom-color: var(--bg-comments-hover-right) !important;\n}\n.item .message-mouth-left-detail[data-v-1f90ed2b]:after {\n  content: '';\n  position: absolute;\n  left: -36px;\n  bottom: 16px;\n  width: 0;\n  height: 0;\n  border-bottom: 12px solid var(--message-left-bgcolor);\n  border-left: 14px solid transparent;\n  border-right: 12px solid transparent;\n  transform: translate(100%, 100%);\n}\n.item.last[data-v-1f90ed2b] {\n  overflow: hidden;\n  transition: all 0.25s;\n  transition-property: height, margin-bottom, opacity;\n  opacity: 0.2;\n}\n.item.height-change[data-v-1f90ed2b] {\n  height: 30px;\n}\n.item.height-change[data-v-1f90ed2b]:last-child {\n  margin-bottom: 0;\n}\n.item.animation[data-v-1f90ed2b] {\n  min-height: 38px;\n  opacity: 1;\n}\n.item.animation.height-change[data-v-1f90ed2b] {\n  height: var(--max-height);\n}\n.item.animation.height-change[data-v-1f90ed2b]:last-child {\n  margin-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
